<template>
<div class="ticket-interface-wrapper">
    <slot></slot>
</div>
</template>

<script>
    export default {
        name: "TicketInterfaceWrapper"
    }
</script>

<style scoped>
.ticket-interface-wrapper {
    height: calc(100vh - 70px);
    display: flex;
    flex-direction: column;
}
</style>
